module.exports = "/assets/bundles/ca6d67e60f758d352745329b283e8f32.png";